<svelte:head>

<script type="text/javascript" src="https://code.jquery.com/jquery-1.11.2.min.js"              on:load={jqueryLoaded}    integrity="sha256-Ls0pXSlb7AYs7evhd+VLnWsZ/AqEHcXBeMZUycz/CcA=" crossorigin="anonymous" defer></script>
<script type="text/javascript" src="https://code.jquery.com/ui/1.11.4/jquery-ui.min.js"        on:load={jqueryuiLoaded}  integrity="sha256-xNjb53/rY+WmG+4L6tTl9m6PpqknWZvRt0rO1SRnJzw=" crossorigin="anonymous" defer></script>

</svelte:head>

<script>

import { onMount, onDestroy } from 'svelte';

import { loggedIn                                                   } from '../_services/accountsession.js';

// ----------------------------------------------------
// --   DECLARATIONS
// ----------------------------------------------------


	let seconds = 0;
   let query_environment = 'dev';
   let query_id = 'sUyO8KVXmwPzWVAk';
   let query_pid = "";

  let display_loadtimer = false;
   
	const interval = 0;

   let display_pivot = false;

	var is_dataLoaded = false;
	onMount(async () => {
		is_dataLoaded = true;
		if ($loggedIn) {
		}
	});

  var is_dependenciesLoaded = false;
  function dependenciesLoaded() {
  		if (   true 
  		       && is_jqueryLoaded 
  		       && is_jqueryuiLoaded 
  		       && is_dataLoaded 
  		   )
  	  {
			is_dependenciesLoaded = true;
	//		buildApplet();
  		}
  }

  var is_jqueryLoaded = false;
  function jqueryLoaded() {
		// The external javascript library is ready.
		is_jqueryLoaded = true;
		dependenciesLoaded();
  }

  var is_jqueryuiLoaded = false;
  function jqueryuiLoaded() {
		// The external javascript library is ready.
		is_jqueryuiLoaded = true;
		dependenciesLoaded();
  }

// ----------------------------------------------------
// --   RUNTIME 
// ----------------------------------------------------

//$: run = is_dependenciesLoaded && handleClickGetResult()  // <<-- should be hanlded in the onMount() ??

$: display_applet = is_dependenciesLoaded;

</script>


<style>

	.applet {
		width: inherit;
		height: inherit;
	}
	
	.jsfiddle {
		width: inherit;
		height: 650px;
	}

</style>


<div class="applet">

	{#if $loggedIn}
	<div>
	</div>
	{:else}
	<div>
	</div>
	{/if}
	
		{#if is_dependenciesLoaded}
	
			{#if  display_applet}
			<iframe class="jsfiddle" title="artififiddle/qnhbax12"
	         src="//jsfiddle.net/artififiddle/qnhbax12/embedded/result/?embed_param_API_KEY=API_KEY&embed_param_CLIENT_ID=CLIENT_ID&embed_param_CLIENT_SECRET=CLIENT_SECRET&embed_param_CLIENT_SESSION=12345678" 
	         allowfullscreen="allowfullscreen" 
	         frameborder="0"></iframe>
		
			{:else if display_loadtimer}
			<div>
				<p>It's been running for {seconds} seconds</p>
				<p>query_pid: {query_pid} </p>
			</div>
		
			{:else}
			<div>
				<p> Scripts loaded </p>		
				<p> Loading data and what not... </p>			
			</div>
	
			{/if}
	
		{:else}
		<div>
			<p> Loading scripts and what not... </p>			
		</div>
	
		{/if}
	

</div>